<div class="headerToolBar">
  <div class="a-daterange-tool-row">
    <div>Last:</div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.q1 }"
      (click)="changeDateRange($event, dateRangeType.q1)"
    >
      Q
    </div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.q2 }"
      (click)="changeDateRange($event, dateRangeType.q2)"
    >
      2Q
    </div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.q3 }"
      (click)="changeDateRange($event, dateRangeType.q3)"
    >
      3Q
    </div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.q4 }"
      (click)="changeDateRange($event, dateRangeType.q4)"
    >
      4Q
    </div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.itd }"
      (click)="changeDateRange($event, dateRangeType.itd)"
    >
      ITD
    </div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.ytd }"
      (click)="changeDateRange($event, dateRangeType.ytd)"
    >
      YTD
    </div>
    <div
      class="a-daterange-tool-btn"
      [ngClass]="{ active: type === dateRangeType.custom }"
      (click)="changeDateRange($event, dateRangeType.custom)"
    >
      Custom
    </div>
  </div>
</div>
